import { render } from "./LeaveActivity.vue?vue&type=template&id=b0738628&ts=true"
import script from "./LeaveActivity.vue?vue&type=script&lang=ts"
export * from "./LeaveActivity.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__